import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardsViewComponent } from './cards-view.component';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { DxScrollViewModule } from 'devextreme-angular';
@NgModule({
  imports: [CommonModule, AbcUiComponentsModule, FlexLayoutModule, MatIconModule, DxScrollViewModule],
  declarations: [CardsViewComponent],
  exports: [CardsViewComponent],
})
export class CardsViewModule {}
